(function () {
  'use strict';

  var EVENT_KEY = 'cdi:addonSync';

  function compute() {
    var addonTotal = 0;
    document.querySelectorAll('[data-addon-select]:checked').forEach(function (el) {
      addonTotal += parseInt(el.dataset.price, 10) || 0;
    });
    publish(EVENT_KEY, { addonTotal: addonTotal, hasAddons: addonTotal > 0 });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches('[data-addon-select]')) {
      compute();
    }
  });

  window.cdiAddonSync = compute;

  function withDelimiters(cents, precision, thousands, decimal) {
    var fixed = (cents / 100).toFixed(precision);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function formatMoney(cents, format) {
    var fmt = format || window.cdiMoneyFormat || '${{amount}}';
    var value = parseInt(cents, 10) || 0;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(value, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(value, 0, ' ', ',');
        case 'amount_with_space_separator': return withDelimiters(value, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return withDelimiters(value, 2, ' ', '.');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  window.cdiFormatMoney = formatMoney;
})();
